// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import { IAccidentEditableData } from '@accidents/shared/interfaces/accidents';

// ----------- General Actions -----------
// ---------------------------------------
export const reset = createAction('[Edit Accident] - Reset');

export const editAccidentRequested = createAction(
  '[Edit Accident] - Edit Accident Requested',
  props<{
    payload: { accidentData: IAccidentEditableData; accidentId: string };
  }>()
);

export const editAccidentResponse = createAction(
  '[Edit Accident] - Edit Accident Response',
  props<{ payload: any }>()
);

export const retrySubmitSAPClaimantsRequested = createAction(
  '[Edit Accident] - Retry Submit Claimants Requested',
  props<{
    payload: { claimantsIdList: string[]; accidentId: string };
  }>()
);

export const retrySubmitSAPClaimantsResponse = createAction(
  '[Edit Accident] - Retry Submit Claimants Response',
  props<{ payload: any }>()
);

export const reprocessAttachmentsRequested = createAction(
  '[Edit Accident] - Reprocess Attachments Requested',
  props<{ payload: { accidentId: string } }>()
);

export const reprocessAttachmentsResponse = createAction(
  '[Edit Accident] - Reprocess Attachments Response',
  props<{ payload: any }>()
);
